export const getClearText = (text) => {
  if (!text) return '';
  return text?.replace(/\uFEFF/g, '')?.trim();
};
